import React, { useState, useEffect } from "react";

const PercentageBar = ({ starText, percentage }) => {

  const [value, setValue] = useState(0);

  useEffect(() => {
    setValue(percentage);
  }, [percentage]);


  return (
    <div class="flexDirection">
      <label class="progressText">{starText} <span role="img" aria-labelledby="panda1" style={{fontSize:20}}> ⭐</span></label>

      <div class="progressMiddle">
        <div class="progressWrap">
            <div style={{ width: `${value}%` }} class="progressBar progress-time" />
        </div>
      </div>
      <label class="progressPercentText">{percentage}%</label>
    </div>
  );
};

export default PercentageBar;